import { render, staticRenderFns } from "./ItemBundling.vue?vue&type=template&id=91b20e0e&"
import script from "./ItemBundling.vue?vue&type=script&lang=js&"
export * from "./ItemBundling.vue?vue&type=script&lang=js&"
import style0 from "./ItemBundling.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports